// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2TQtO","alert":"SettungsInbox_alert__2gWYM"};